"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SideTrayRenderer = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _reactI18next = require("react-i18next");

var _coreAnimate = _interopRequireDefault(require("@legacy-vfuk/core-animate"));

var _coreOverlay = _interopRequireDefault(require("@legacy-vfuk/core-overlay"));

var _coreIconButton = _interopRequireDefault(require("@legacy-vfuk/core-icon-button"));

var _coreSimpleGrid = _interopRequireDefault(require("@legacy-vfuk/core-simple-grid"));

var _coreHelpers = require("@legacy-vfuk/core-helpers");

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var _coreThemes = require("@legacy-vfuk/core-themes");

var Styled = _interopRequireWildcard(require("./styles/SideTrayRenderer.style"));

var _SideTrayRenderer2 = _interopRequireDefault(require("./themes/SideTrayRenderer.theme"));

var _Renderer2 = _interopRequireDefault(require("../Renderer"));

var _setInitialFocus = _interopRequireDefault(require("../utils/setInitialFocus"));

var _constants = require("../constants/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SideTrayRenderer = /*#__PURE__*/function (_Renderer) {
  _inherits(SideTrayRenderer, _Renderer);

  var _super = _createSuper(SideTrayRenderer);

  function SideTrayRenderer() {
    _classCallCheck(this, SideTrayRenderer);

    return _super.apply(this, arguments);
  }

  _createClass(SideTrayRenderer, [{
    key: "columnWidths",
    value: function columnWidths(size) {
      if (size === 1) {
        return {
          sm: [12],
          md: [5],
          lg: [3]
        };
      }

      if (size === 2) {
        return {
          sm: [12],
          md: [6],
          lg: [5]
        };
      }

      return {
        sm: [12],
        md: [9],
        lg: [6]
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this,
          _this$props$localThem,
          _this$props$localThem2;

      var animationDuration = this.props.animate ? 200 : 0;
      return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(Styled.SideTrayRenderer, _extends({
        zIndex: this.props.zIndex,
        topOffset: this.props.topOffset,
        id: this.props.id,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": this.props.componentName
      }, this.props.dataAttributes), /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
        show: this.state.show,
        enter: {
          animations: this.props.animate ? ["slideFrom".concat((0, _coreHelpers.capitalizeFirstCharacter)(this.props.side))] : ['none'],
          duration: animationDuration,
          delay: animationDuration,
          onDone: function onDone() {
            return (0, _setInitialFocus["default"])(_this.props.initialFocusId);
          }
        },
        exit: {
          animations: this.props.animate ? ["slideTo".concat((0, _coreHelpers.capitalizeFirstCharacter)(this.props.side))] : ['none'],
          duration: animationDuration,
          onDone: this.onDoneCallback
        }
      }, /*#__PURE__*/_react["default"].createElement(Styled.Container, {
        zIndex: this.props.zIndex + 1,
        side: this.props.side
      }, /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
        layout: this.columnWidths(this.props.size),
        verticalAlign: "stretch",
        justify: this.props.side,
        spacing: 0
      }, /*#__PURE__*/_react["default"].createElement(Styled.SideTray, {
        side: this.props.side,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'content'),
        appearance: this.props.appearance,
        sideTrayTheme: this.props.localTheme
      }, /*#__PURE__*/_react["default"].createElement(_reactFocusLock["default"], {
        shards: this.props.focusEnabledRefs
      }, this.props.isClosable && /*#__PURE__*/_react["default"].createElement(Styled.CloseButton, {
        "aria-label": this.props.srName,
        animationDuration: animationDuration,
        side: this.props.side
      }, /*#__PURE__*/_react["default"].createElement(_coreIconButton["default"], {
        srText: this.props.t('Close'),
        icon: {
          name: 'close'
        },
        appearance: (_this$props$localThem = this.props.localTheme) === null || _this$props$localThem === void 0 ? void 0 : _this$props$localThem.appearance[this.props.appearance].closeIconAppearance,
        inverse: (_this$props$localThem2 = this.props.localTheme) === null || _this$props$localThem2 === void 0 ? void 0 : _this$props$localThem2.appearance[this.props.appearance].inverseCloseIcon,
        size: 4,
        onClick: this.getOnCloseHandler(_constants.OverlayCloseSource.SIDETRAY_CROSS_CLICK),
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'close-button')
      })), this.props.children))))), this.props.enableOverlay && /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
        show: this.state.show,
        enter: {
          animations: this.props.animate ? ['fadeIn'] : ['none'],
          duration: this.props.animate ? 400 : 0
        },
        exit: {
          animations: this.props.animate ? ['fadeOut'] : ['none'],
          duration: animationDuration
        }
      }, /*#__PURE__*/_react["default"].createElement(_coreOverlay["default"], {
        show: true,
        onClick: this.props.isClosable ? this.getOnCloseHandler(_constants.OverlayCloseSource.SIDETRAY_OUTSIDE_CLICK) : undefined,
        position: "fixed",
        zIndex: 0,
        blur: this.props.overlayBlur,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'overlay')
      }))), this.props.rootElement);
    }
  }]);

  return SideTrayRenderer;
}(_Renderer2["default"]);

exports.SideTrayRenderer = SideTrayRenderer;
SideTrayRenderer.defaultProps = {
  side: 'left',
  size: 1,
  overlayBlur: false,
  enableOverlay: false,
  isClosable: true,
  topOffset: '0',
  appearance: 'primary'
};
SideTrayRenderer.displayName = "SideTrayRenderer";

var _default = (0, _reactI18next.withTranslation)()((0, _coreThemes.withLocalTheme)(SideTrayRenderer, _SideTrayRenderer2["default"]));

exports["default"] = _default;
//# sourceMappingURL=SideTrayRenderer.js.map